import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const LightBulb = ({ color = "#000", ...props }: IconProps) => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9861_231)" {...props}>
                <path
                    d="M5.28616 12.6252C5.08816 11.7766 4.19483 11.0826 3.82816 10.6252C3.20029 9.84076 2.80679 8.89487 2.693 7.89654C2.57921 6.8982 2.74976 5.88803 3.185 4.98239C3.62023 4.07675 4.30245 3.31248 5.15306 2.77762C6.00368 2.24276 6.98808 1.95907 7.99288 1.95923C8.99768 1.95939 9.98199 2.24339 10.8324 2.77853C11.6829 3.31366 12.3649 4.07815 12.7998 4.98393C13.2347 5.88971 13.405 6.89994 13.2909 7.89824C13.1767 8.89653 12.783 9.84229 12.1548 10.6266C11.7882 11.0832 10.8962 11.7772 10.6982 12.6252H5.28549H5.28616ZM10.6588 13.9586V14.6252C10.6588 14.9788 10.5184 15.318 10.2683 15.568C10.0183 15.8181 9.67912 15.9586 9.32549 15.9586H6.65883C6.30521 15.9586 5.96607 15.8181 5.71602 15.568C5.46597 15.318 5.32549 14.9788 5.32549 14.6252V13.9586H10.6588ZM8.65883 7.29523V4.62523L5.65883 8.62856H7.32549V11.2952L10.3255 7.29523H8.65883Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_9861_231">
                    <rect width="16" height="16" fill="white" transform="translate(-0.0078125 0.625244)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default LightBulb
